import { Icon, IconName, IconSize } from '@ardoq/icons';
import { ReactElement } from 'react';
import { colors } from '@ardoq/design-tokens';
import { IconButton } from '@ardoq/button';
import { t, type I18nLocale } from '@ardoq/i18n';
import {
  RowLabel,
  RowContainer,
  RowLeftContentContainer,
  TagsContainer,
} from './atoms';

type AppliedSettingRowProps = {
  label: string;
  icon: IconName;
  onEditClick?: () => void;
  tags?: ReactElement[];
  isDisabled?: boolean;
  i18nLocale: I18nLocale;
};
export const AppliedSettingsRow = ({
  label,
  icon,
  onEditClick,
  tags,
  isDisabled,
  i18nLocale,
}: AppliedSettingRowProps) => (
  <RowContainer>
    <RowLeftContentContainer $isDisabled={isDisabled}>
      <Icon
        iconName={icon}
        iconSize={IconSize.MEDIUM}
        style={{ color: colors.grey400 }}
      />
      <RowLabel>{label}</RowLabel>
      <TagsContainer>{tags}</TagsContainer>
    </RowLeftContentContainer>

    {onEditClick ? (
      <IconButton
        label={t(i18nLocale, 'appLayout:editLabel', 'Edit')}
        iconName={IconName.EDIT}
        onClick={onEditClick}
      />
    ) : null}
  </RowContainer>
);
